/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneOptionalLink from 'base/components/standalone/OptionalLink';

export const DynamicStandaloneOptionalLink = StandaloneOptionalLink;
export type DynamicStandaloneOptionalLinkProps = PropsFromComponent<typeof StandaloneOptionalLink>;

export const DynamicStandaloneOptionalLinkWith = (extras: DynamicStandaloneExtras): typeof StandaloneOptionalLink => {
    return function DynamicStandaloneOptionalLink(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'OptionalLink');
        return <StandaloneOptionalLink {...mergeProps({ options: { theme } }, props)} />;
    }
}